export default __webpack_public_path__ + "static/media/thunder_form.9de9beab.svg";